module.exports = __webpack_public_path__ + "img/confirm.8ad9b958.png";